import {ProductType} from '@/commons/enums/ProductType';
import {ProcessType} from '@/commons/enums/ProcessType';
import {IMultiformDictionaryElement} from '@/modules/multiForm/shared/IMultiformDictionary';
import {BankSymbol} from '@/commons/dictionaries/BankSymbol';
import {CreditDetails} from '@/modules/multiForm/shared/MultiformModels';
import {SettledDocumentsLabels} from '@/modules/deals/enums/DocumentsStatus';

export interface BankMetaData {
  creditDetailsClass?: typeof CreditDetails,
  isMultiformValidationOn?: boolean,
}

export enum RequiredStatus {
  NEEDED = 'needed',
  UNNEEDED = 'unneeded',
  OPTIONAL = 'optional',
}

export class ProductConfig {
  processRestrictions?: Array<ProcessType> = [];
  centralLink?: string;
  requiredDocuments?: PartialRecord<SettledDocumentsLabels, RequiredStatus> = {};
}

export type ProductsData = Partial<Record<ProductType, boolean>>;
export interface RepresentativeExamples {
  productTypeMortgage: string,
  productTypeCash: string,
}
export class BankDictionaryElementDTO implements IMultiformDictionaryElement<BankSymbol> {
  id?: number;
  type!: BankSymbol;
  name_pl: string = '';
  logoUrl?: Nullable<string> = null;
  meta?: BankMetaData;
  color?: string = '';
  textColor?: string = '#FFFFFF';
  enabled?: boolean;
  productsConfig?: Partial<Record<ProductType, ProductConfig>>;
  representativeExamples?: RepresentativeExamples;
  institutionType?: string;

  products?: ProductsData = {
    [ProductType.MORTGAGE]: false,
    [ProductType.SME]: false,
    [ProductType.NONBANK]: false,
    [ProductType.CASH]: false,
    [ProductType.INSURANCE]: false,
    [ProductType.REAL_ESTATE]: false,
  };
}

export class NewBankElement extends BankDictionaryElementDTO {
  type: BankSymbol = BankSymbol.NONE;
  enabled: boolean = true;
  productsConfig: Partial<Record<ProductType, ProductConfig>> = {
    [ProductType.CASH]: {
      processRestrictions: [ProcessType.Department,],
    },
  };

  representativeExamples?: RepresentativeExamples = {
    productTypeMortgage: '',
    productTypeCash: '',
  };
}

export type BackendBankModel = {
  id?: number;
  symbol: BankSymbol;
  name: string;
  color?: string;
  textColor?: string;
  logoUrl?: Nullable<string>;
  products?: ProductsData;
  meta?: BankMetaData;
  enabled?: boolean;
  productsConfig?: Partial<Record<ProductType, ProductConfig>>;
  representativeExamples?: RepresentativeExamples;
  institutionType?: string;
}

export const financialInstitutions: BankDictionaryElementDTO[] = [];
